import {Component, OnInit, ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../../rest-api.service';
import {MessageService} from '../../message.service';
import {FormControl} from '@angular/forms';
import {AngularGridInstance, Column, Formatters, GridOption} from 'angular-slickgrid';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-docu',
  templateUrl: './view-docu.component.html',
  styleUrls: ['./view-docu.component.css']
})
export class ViewDocuComponent implements OnInit {

  radioButton: any;
  displayed = false;

  ticketTypes: any;
  name: string;
  brief: string;
  rDate = '';
  dDate = '';
  clientId: any;
  private notifier: NotifierService;
  respObject: any;

  radioChecked: any;
  cat = [];
  attachment = [];
  uploadButtonName = 'Upload File';
  fileUploadUrl: string;
  add = false;
  public clientName: string;
  private typeSeq: number | string | any;
  groups = [];
  supportGroupSelected = [];
  users = [];
  userSelected = [];
  download: boolean;
  upload: boolean;
  deleted: boolean;
  emailSearch: string;
  textSelected: any;
  isLoading = false;
  searchTerm: FormControl = new FormControl();
  docs = [];
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset = [];
  angularGrid: AngularGridInstance;
  gridObj: any;
  @ViewChild('content') private content;
  private modalReference: NgbModalRef;
  docuId: any;
  title: string;
  desc: string;
  creator: string;
  categories = [];
  actions = [];
  sGroups = [];
  sUsers = [];
  formData: any;
  attachments = [];
  comment: string;
  comments = [];
  comLoaded: boolean;
  delete: boolean;
  dId: string;
  private oldtitle: string;
  private oldDesc: string;
  private oldrDate = '';
  private olddDate = '';

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    const classes = document.getElementsByClassName('search-filter');
    for (let i = 0; i < classes.length; i++) {
      classes[i].setAttribute('placeholder', '');
    }
  }

  constructor(private _rest: RestApiService, notifier: NotifierService,
              private messageService: MessageService, private modalService: NgbModal) {
    this.notifier = notifier;
    this.searchTerm.valueChanges.subscribe(
      word => {
        // console.log(typeof word);
        // if (word.length > 3) {
        this.isLoading = true;
        this._rest.autoSearch(this.clientId, word).subscribe((res1) => {
          this.respObject = res1;
          this.isLoading = false;
          this.docs = this.respObject.details;
          // if (this.respObject.success) {
          //
          //   this.docs = this.respObject.details;
          // } else {
          // }
        }, (err) => {
          this.isLoading = false;
        });
        // }
      });
  }

  ngOnInit() {

    this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
    this.columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      {id: 'id', name: 'Id', field: 'id', minWidth: 50, sortable: true, filterable: true},
      {id: 'dId', name: 'Docu ID', field: 'docu_id', minWidth: 100, sortable: true, filterable: true},
      {id: 'Title', name: 'Title', field: 'title', minWidth: 100, sortable: true, filterable: true},
      {
        id: 'name', name: 'Created By', field: 'name', minWidth: 100, sortable: true, filterable: true
      },
      {
        id: 'StartDate', name: 'Start Date', field: 'startDate', minWidth: 60, sortable: true, filterable: true
      },
      {
        id: 'EndDate', name: 'Expiry Date', field: 'endDate', sortable: true, minWidth: 100, filterable: true
      },
    ];
    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true
    };
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        this.clientName = this.respObject.details[0].client;
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          // console.log('ticket type=', JSON.stringify(this.respObject));
          if (this.respObject.success) {
            // this.radioChecked = this.respObject.details[0].id;
            for (let i = 0; i < this.respObject.details.length; i++) {
              if (this.respObject.details[i].seq === this.messageService.DOCU_TYPE) {
                this.radioChecked = this.respObject.details[i].id;
                break;
              }
            }
            // console.log('this.displayed:' + this.displayed);
            this.typeSeq = this.respObject.details[0].seq;
            this.radioButton = this.respObject.details;
            this.getTicketLoadingData();
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });


  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  getTicketLoadingData() {
    this._rest.getDocuTicketDetails(this.messageService.getUserId(), this.radioChecked).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.ticketTypes = this.respObject.details[0].attribute;
        this.clientId = this.respObject.details[0].clientId;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  onCategoryChange(ticket, option) {
    console.log(JSON.stringify(ticket), typeof option, ticket.id);
    // if(this.ticketTypes)

    const opt = JSON.parse(option);
    if (opt.type !== 'header') {
      if (this.attachment.length > 0) {
        this.attachment = [];
      }
      const value = opt.id;
      // let matched = false;
      const index = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id + 1);
      // console.log('index:' + index);
      // const index1 = this.ticketTypes.map(function (d) {
      //   return d['id'];
      // }).indexOf(ticket.id);
      // const pid = this.ticketTypes[index1].options[0].id;
      // if (this.cat.length === 0) {
      //   this.cat.push({pid: pid, cid: value});
      // } else {
      //   for (let i = 0; i < this.cat.length; i++) {
      //     if (this.cat[i].pid === pid) {
      //       matched = true;
      //       this.cat[i].cid = value;
      //       break;
      //     }
      //   }
      //   if (!matched) {
      //     this.cat.push({pid: pid, cid: value});
      //   } else {
      //     for (let i = index; i < this.cat.length; i++) {
      //       // console.log('matched');
      //       // console.log(this.cat[i]);
      //       if (index > -1) {
      //         this.cat[i].cid = 0;
      //       }
      //     }
      //   }
      // }

      // clear sub categories
      if (index > -1) {
        // console.log('index:' + index);
        for (let i = index + 1; i < this.ticketTypes.length; i++) {
          const options = this.ticketTypes[i].options;
          // console.log(JSON.stringify(options));
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.ticketTypes[i].options = [options[j]];
              break;
            }
          }
        }
      }

      // let cats = '';
      // // console.log(JSON.stringify(this.cat));
      // for (let i = 0; i < this.cat.length; i++) {
      //   if (this.cat[i].cid !== 0) {
      //     cats += this.cat[i].cid;
      //     console.log(i, this.cat.length - 1);
      //     if (i !== this.cat.length - 1) {
      //       console.log('inside');
      //       cats += ',';
      //     }
      //   }
      // }
      // // console.log(cats, cats.substring(cats.length - 1, cats.length));
      // if (cats.substring(cats.length - 1, cats.length) === ',') {
      //   cats = cats.substring(0, cats.length - 1);
      // }
      // console.log(cats);
      this._rest.getDataByCategory(this.clientId, value, this.messageService.getUserId()).subscribe((res1) => {
        this.respObject = res1;
        // this.dataset = [];
        if (this.respObject.success) {
          this.dataset = this.respObject.details;
          console.log(JSON.stringify(this.dataset));
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
      this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
        this.respObject = res;
        let data;
        if (index > -1) {
          data = this.ticketTypes[index].options[0];
        }
        if (this.respObject.success) {

          this.respObject.details.unshift(data);
          this.ticketTypes[index].options = this.respObject.details;
        } else {
          if (index > -1) {
            this.ticketTypes[index].options = [data];
          }
          // this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }

  searchWithEmail($event) {
    console.log('clicked', this.emailSearch);
    this._rest.getDataByEmail(this.clientId, btoa(this.messageService.xorEncode(this.emailSearch, this.messageService.SECRET_TOKEN)),
      this.messageService.getUserId()).subscribe((res1) => {
      this.respObject = res1;
      // this.dataset = [];
      if (this.respObject.success) {
        this.dataset = this.respObject.details;
        console.log(JSON.stringify(this.dataset));
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  tabClick(event) {
    if (event.tab.textLabel === 'Comments') {
      this.getComments();
    } else if (event.tab.textLabel === 'Attachments') {
      this._rest.getAttachmentByDocuId(this.docuId).subscribe((res1) => {
        this.respObject = res1;
        // console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          for (let i = 0; i < this.respObject.details.length; i++) {
            this.respObject.details[i].attacheMent = this.messageService.UPLOAD_PATH + this.respObject.details[i].path;
          }
          this.attachments = this.respObject.details;
        } else {
          // this.notifier.notify('error', this.respObject.errorMessage);
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }

  }

  getComments() {
    this._rest.getCommentsByDocuId(this.docuId).subscribe((res1) => {
      this.respObject = res1;
      console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.comments = this.respObject.details;
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  onTicketChange(ticket, option) {
    const opt = JSON.parse(option);
    // console.log(JSON.stringify(ticket));
    if (opt.type !== 'header') {
      const value = opt.id;
      let matched = false;
      const index = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id + 1);
      const index1 = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id);
      console.log(index1);
      // let pid;
      // if (index1 > 0) {
      //   pid = this.ticketTypes[index1].options[0].id;
      // } else {
      //   pid = this.ticketTypes[index1].options[1].id;
      // }
      const pid = this.ticketTypes[index1].options[0].id;
      console.log(this.ticketTypes[index1].options[0], pid);
      if (this.cat.length === 0) {
        this.cat.push({pid: pid, cid: value});
      } else {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].pid === pid) {
            matched = true;
            this.cat[i].cid = value;
            break;
          }
        }
        if (!matched) {
          this.cat.push({pid: pid, cid: value});
        } else {
          for (let i = index; i < this.cat.length; i++) {
            this.cat[i].cid = 0;
          }
        }
      }
      // console.log('---->' + JSON.stringify(this.cat));
      console.log(value);
      let data;
      for (let i = 0; i < this.ticketTypes[index].options.length; i++) {
        if (this.ticketTypes[index].options[i].type) {
          data = this.ticketTypes[index].options[i];
        }
      }
      if (index > -1) {
        for (let i = index + 1; i < this.ticketTypes.length; i++) {
          const options = this.ticketTypes[i].options;
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.ticketTypes[i].options = [options[j]];
              break;
            }
          }
        }
      }
      // console.log(JSON.stringify(this.ticketTypes), ticket.id);

      this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
        this.respObject = res;

        if (this.respObject.success) {
          this.respObject.details.unshift(data);
          // console.log(JSON.stringify(this.respObject.details));
          this.categories[index].options = this.respObject.details;
        } else {
          // this.notifier.notify('error', this.respObject.errorMessage);
          if (this.respObject.errorMessage === 'No data found') {
            this.categories[index].options = [data];
          }
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }

  onCellClicked(e: any, args: any) {
    const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
    const data = selectedRow.dataContext;
    this.upload = data.upload;
    this.download = data.download;
    this.delete = data.delete;
    if (selectedRow.columnDef.id === 'delete') {
      // selectedRow.dataContext.type = 'delete';
      const data1 = {
        id: data.id,
        user_id: this.messageService.getUserId()
      };
      if (this.delete) {
        if (confirm('Are you sure to delete the permission?')) {
          this._rest.deleteDocument(data1).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
              this.angularGrid.gridService.deleteDataGridItemById(data.id);
            } else {
              this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.respObject.errorMessage);
          });
        }
      } else {
        this.notifier.notify('error', 'You do not have delete permission on this document');
      }
    } else {
      this.creator = data.name;
      this.docuId = data.id;
      this.dId = data.docu_id;
      this.title = data.title;
      this.oldtitle = data.title;
      this.desc = data.keyword;
      this.oldDesc = data.keyword;
      this.cat = [];
      this.sUsers = [];
      this.sGroups = [];
      this.rDate = data.startDate;
      this.dDate = data.endDate;
      this.oldrDate = data.startDate;
      this.olddDate = data.endDate;
      this.comLoaded = true;

      this.formData = {docuId: data.id, clientId: this.clientId, title: data.title, createdBy: this.messageService.getUserId()};
      this.modalReference = this.modalService.open(this.content, {size: 'lg', windowClass: 'large-modal'});
      this._rest.getDocumentDetails(this.clientId, this.docuId, this.radioChecked).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          // this.respObject.details.unshift({id: 0, name: 'All User'});
          // this.users = this.respObject.details;
          this.categories = this.respObject.details.cat;
          // this.respObject.details.users.unshift({id: 0, name: 'All User'});
          // this.users = this.respObject.details.users;
          // this.respObject.details.groups.unshift({id: 0, name: 'All Groups'});
          // this.groups = this.respObject.details.groups;
          // this.userSelected = this.respObject.details.selectedUsers;
          // this.supportGroupSelected = this.respObject.details.selectedgroups;
          // console.log(JSON.stringify(this.users));
          // this.userSelected = 0;
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
      this._rest.getActionsByDocuId(this.clientId, this.docuId).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.actions = this.respObject.details;
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    }
  }

  onFileComplete(data: any) {
    this.attachment = [];
    if (data.success) {
      this.attachment.push({originalName: data.fileName, fileName: data.changedName});
    }
  }

  // checkAll(checked: boolean, index: any) {
  //   if (this.actions[index].id === 4) {
  //     if (checked) {
  //       for (let i = 0; i < this.actions.length; i++) {
  //         this.actions[i].checked = true;
  //       }
  //     } else {
  //       for (let i = 0; i < this.actions.length; i++) {
  //         this.actions[i].checked = false;
  //       }
  //     }
  //   } else {
  //     if (!checked) {
  //       for (let i = 0; i < this.actions.length; i++) {
  //         if (this.actions[i].id === 4) {
  //           this.actions[i].checked = false;
  //           break;
  //         }
  //       }
  //     }
  //   }
  //   // console.log(checked, JSON.stringify(this.actions[i]), i);
  // }

  // onGroupChange() {
  //   this.sGroups = [];
  //   if (this.supportGroupSelected.indexOf(0) > -1) {
  //     this.supportGroupSelected = [];
  //     for (let i = 0; i < this.groups.length; i++) {
  //       if (this.groups[i].id !== 0) {
  //         this.sGroups.push(this.groups[i].id);
  //         this.groups[i].isDisabled = true;
  //       }
  //       this.supportGroupSelected.push(this.groups[i].id);
  //     }
  //   } else {
  //     for (let i = 0; i < this.groups.length; i++) {
  //       if (this.groups[i].id !== 0) {
  //         this.groups[i].isDisabled = false;
  //       }
  //     }
  //     for (let i = 0; i < this.supportGroupSelected.length; i++) {
  //       this.sGroups.push(this.supportGroupSelected[i]);
  //     }
  //   }
  //   console.log(JSON.stringify(this.supportGroupSelected));
  //   if (this.sGroups.length > 0) {
  //     this._rest.getUsersByMultiGroup(this.clientId, this.sGroups).subscribe((res1) => {
  //       this.respObject = res1;
  //       if (this.respObject.success) {
  //         this.respObject.details.unshift({id: 0, name: 'All User'});
  //         this.users = this.respObject.details;
  //         // console.log(JSON.stringify(this.users));
  //         // this.userSelected = 0;
  //       } else {
  //         this.notifier.notify('error', this.respObject.errorMessage);
  //       }
  //     }, (err) => {
  //       this.notifier.notify('error', this.messageService.SERVER_ERROR);
  //     });
  //   } else {
  //     this.users = [];
  //   }
  // }
  //
  // onUserChange() {
  //   this.sUsers = [];
  //   if (this.userSelected.indexOf(0) > -1) {
  //     this.userSelected = [];
  //     for (let i = 0; i < this.users.length; i++) {
  //       if (this.users[i].id !== 0) {
  //         this.sUsers.push(this.users[i].id);
  //         this.users[i].isDisabled = true;
  //       }
  //       this.userSelected.push(this.users[i].id);
  //     }
  //   } else {
  //     for (let i = 0; i < this.users.length; i++) {
  //       if (this.users[i].id !== 0) {
  //         this.users[i].isDisabled = false;
  //       }
  //     }
  //     for (let i = 0; i < this.userSelected.length; i++) {
  //       this.sUsers.push(this.userSelected[i]);
  //     }
  //   }
  // }

  // get selectedOptions() {
  //   return this.actions
  //     .filter(opt => opt.checked)
  //     .map(opt => opt.id);
  //
  // }

  update() {
    // if (this.selectedOptions.length > 0) {
    // if (this.supportGroupSelected.length > 0 && this.sGroups.length === 0) {
    //   if (this.supportGroupSelected.indexOf(0) > -1) {
    //     this.supportGroupSelected = [];
    //     for (let i = 0; i < this.groups.length; i++) {
    //       if (this.groups[i].id !== 0) {
    //         this.sGroups.push(this.groups[i].id);
    //         this.groups[i].isDisabled = true;
    //       }
    //       this.supportGroupSelected.push(this.groups[i].id);
    //     }
    //   } else {
    //     for (let i = 0; i < this.groups.length; i++) {
    //       if (this.groups[i].id !== 0) {
    //         this.groups[i].isDisabled = false;
    //       }
    //     }
    //     for (let i = 0; i < this.supportGroupSelected.length; i++) {
    //       this.sGroups.push(this.supportGroupSelected[i]);
    //     }
    //   }
    // }
    // if (this.userSelected.length > 0 && this.sUsers.length === 0) {
    //   if (this.userSelected.indexOf(0) > -1) {
    //     this.userSelected = [];
    //     for (let i = 0; i < this.users.length; i++) {
    //       if (this.users[i].id !== 0) {
    //         this.sUsers.push(this.users[i].id);
    //         this.users[i].isDisabled = true;
    //       }
    //       this.userSelected.push(this.users[i].id);
    //     }
    //   } else {
    //     for (let i = 0; i < this.users.length; i++) {
    //       if (this.users[i].id !== 0) {
    //         this.users[i].isDisabled = false;
    //       }
    //     }
    //     for (let i = 0; i < this.userSelected.length; i++) {
    //       this.sUsers.push(this.userSelected[i]);
    //     }
    //   }
    // }
    let cats = '';
    let isError = false;

    console.log(JSON.stringify(this.cat));
    if (this.cat.length > 0) {
      if (this.cat.length === this.ticketTypes.length) {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].cid !== 0) {
            cats += this.cat[i].pid + '#' + this.cat[i].cid;
            if (i !== this.cat.length - 1) {
              cats += ',';
            }
          } else {
            isError = true;
            break;
          }
        }
      } else {
        isError = true;
      }
    }
    console.log(cats);

    if (isError) {
      this.notifier.notify('error', this.messageService.CATEGORY_ERROR);
    } else {
      // const allActions = [];
      // for (let j = 0; j < this.selectedOptions.length; j++) {
      //   if (this.selectedOptions[j] !== 4) {
      //     allActions.push(this.selectedOptions[j]);
      //   }
      // }
      const data = {
        'clientId': this.clientId,
        // 'title': this.name,
        // 'longDesc': this.desc,
        // 'requestedDate': this.rDate,
        // 'dueDate': this.dDate,
        'createdBy': this.messageService.getUserId(),
        'docuId': this.docuId
      };
      if (this.oldtitle !== this.title) {
        data['title'] = this.title;
      }
      if (this.oldDesc !== this.desc) {
        data['longDesc'] = this.desc;
      }
      if (this.oldrDate !== this.rDate) {
        data['requestedDate'] = this.rDate;
      }
      if (this.olddDate !== this.dDate) {
        data['dueDate'] = this.dDate;
      }
      console.log(JSON.stringify(data));
      if (!this.messageService.isBlankField(data)) {
        data['categoryDtlsLt'] = cats;
        this._rest.updateDocument(data).subscribe((res) => {
          this.respObject = res;
          if (this.respObject.success) {
            alert('Document updated successfully.');
          } else {
            alert(this.respObject.errorMessage);
          }
        }, (err) => {
          alert(this.messageService.SERVER_ERROR);
        });
      } else {
        alert(this.messageService.BLANK_ERROR_MESSAGE);
      }
    }
    // } else {
    //   alert(this.messageService.BLANK_ACTION);
    // }
  }

  textSearch() {
    console.log(this.textSelected);
    this._rest.getDataByText(this.clientId, this.textSelected,
      this.messageService.getUserId()).subscribe((res1) => {
      this.respObject = res1;
      // this.dataset = [];
      if (this.respObject.success) {
        this.dataset = this.respObject.details;
        // console.log(JSON.stringify(this.dataset));
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  addComment() {
    if (this.comment && this.comment !== '') {
      const data = {
        docuId: this.docuId,
        createdBy: this.messageService.getUserId(),
        feedback: this.comment
      };
      // console.log(JSON.stringify(data));
      this.comLoaded = false;
      this._rest.addDocuComment(data).subscribe((res1) => {
        this.respObject = res1;
        this.comLoaded = true;
        if (this.respObject.success) {
          this.comment = '';
          this.getComments();
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else {
      alert(this.messageService.BLANK_COMMENT);
    }
  }

  dateSearch() {

  }

  downloadFile() {

  }
}
